import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { EMPTY, map, tap } from 'rxjs';
import { BookingOrderModel, BookingStatus } from '../models/booking.model';
import { SYSTEM_CODE } from '../constants/app.constant';
import { BookingService } from '@services/booking.service';
import { ToastService } from '@services/toast.service';
import { BaseResponseModel } from '@models/app.model';
import { TranslateService } from '@ngx-translate/core';

export const changeFlightResolver: ResolveFn<BaseResponseModel<BookingOrderModel> | null> = (
    route
) => {
    const bookingService = inject(BookingService);
    const toastService = inject(ToastService);
    const translateService = inject(TranslateService);
    const router = inject(Router);
    const code = route.queryParamMap.get('code');

    if (!code) {
        router.navigate(['booking', 'manage']);
        return EMPTY;
    }
    const allowChangeFlightCode = (code: string) => [SYSTEM_CODE.VJ, SYSTEM_CODE.VNA].includes(code as SYSTEM_CODE);
    const allowStatus = [BookingStatus.IssueTicket];

    const handleError = (message: string, duration = 4000) => {
        toastService.showError(translateService.instant('common.tabs.cancel'), message, duration);
        router.navigate(['booking', 'manage']);
    };

    return bookingService.getDetailBooking(code).pipe(
        tap((detail) => {
            if (!detail?.Data.BookingCode) {
                handleError(translateService.instant('pages.booking.toast.messages.bookingFailed'));
                return;
            }

            // for VNA
            if (detail.Data.SystemCode === SYSTEM_CODE.VNA) {
                allowStatus.push(BookingStatus.Reservation);
            }

            const isAllowChangeFlight =
                allowStatus.includes(detail.Data.BookingStatusId) &&
                allowChangeFlightCode(detail.Data.SystemCode);

            if (!isAllowChangeFlight) {
                handleError(translateService.instant('pages.booking.messages.canChangeFlight'));
            }
        }),
        map((detail) => ({ ...detail, TransactionId: code }))
    );
};
